import React from 'react'
import logo from "../../Images/logo1.png"
import { Row, Col, Nav } from "react-bootstrap"
import "./Fotter.css"
import { NavLink } from 'react-router-dom'
function Fotter() {
    return (
        <>
            <div className="container footer_main">
                <div className="fot_in">
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} className="col_one">
                            <div className="f_img">
                                <img src={logo} className="fotter_img" />
                            </div>
                        </Col>
                        <Col xl={3} lg={3} md={3} sm={6} xs={12} className="col_two">
                            <div>
                                <h3 className="menu">Menu</h3>
                                <Nav.Link href="#homes" className="footer_Link">Home</Nav.Link>
                                <Nav.Link href="#about" className="footer_Link">About</Nav.Link>
                                <Nav.Link href="#memes" className="footer_Link">Mint</Nav.Link>
                                <Nav.Link href="#road" className="footer_Link">Roadmap</Nav.Link>
                                <Nav.Link href="#memes" className="footer_Link">Faq's</Nav.Link>
                            </div>
                        </Col>
                        <Col xl={3} lg={3} md={3} sm={6} xs={12} className="col_three">
                            <div>
                                <h3 className="menu">Social</h3>
                                <Nav.Link target='_blank' href="https://twitter.com/SolarBearsNFT" className="footer_Link">Twitter</Nav.Link>
                                {/* <Nav.Link target='_blank' href="https://www.instagram.com/" className="footer_Link">Instagram</Nav.Link> */}
                                <Nav.Link target='_blank' href="https://discord.gg/XYRkqRg9" className="footer_Link">Discord</Nav.Link>

                            </div>
                        </Col>
                    </Row>
                    <br />
                    <div>
                        <h4 className="text_end">Copyright © 2021 Solarbears. All rights reserved.</h4>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Fotter
